import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface SetEnabledStatusForSchedulesParams extends IMultipleIdsParams {
  enabled: boolean;
}

export class SetEnabledStatusForSchedulesRequest extends Request<SetEnabledStatusForSchedulesParams, IResult> {
  constructor(ids: string[], enabled: boolean) {
    super('setEnabledStatusForSchedules', { ids: ids, enabled: enabled });
  }
}
